import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "add_FILL1_wght600_GRAD0_opsz48",
		d: "M18,26.5a1.151,1.151,0,0,1-1.172-1.172V19.172H10.672a1.172,1.172,0,1,1,0-2.345h6.155V10.672a1.172,1.172,0,1,1,2.345,0v6.155h6.155a1.172,1.172,0,1,1,0,2.345H19.172v6.155A1.151,1.151,0,0,1,18,26.5Z",
		transform: "translate(-9.5 -9.5)",
		fill: "#fff"
	})
});
export { SvgIconPlus as ReactComponent };
